import { render, staticRenderFns } from "./RiskCap.vue?vue&type=template&id=b89e3bba&scoped=true&"
import script from "./RiskCap.vue?vue&type=script&lang=js&"
export * from "./RiskCap.vue?vue&type=script&lang=js&"
import style0 from "./RiskCap.vue?vue&type=style&index=0&id=b89e3bba&scoped=true&lang=css&"
import style1 from "./RiskCap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89e3bba",
  null
  
)

export default component.exports